export default __webpack_public_path__ + "static/media/silhouette_choice.71e90640.png";